import type { ChatPlugin } from '#types/plugin/chat'
import enhancedLiveChat from '#core/integrations/enhanced-live-chat'
import sierraChat from '#core/integrations/sierra-chat'
import { languageConfig } from '../../config/integrations/livechat'

export default defineNuxtPlugin<{ chat: ChatPlugin }>(() => {
  const { enableChat, configLivechat } = useFeatureFlags()
  const locale = useLocale()

  if (!enableChat) {
    const open = () => console.warn('Chat is disabled by feature flag')
    open()

    return {
      provide: {
        chat: {
          open,
          available: ref(false)
        }
      }
    }
  }

  if (configLivechat.enabled && configLivechat.sierraRegions?.includes(locale)) {
    return sierraChat({
      hideLauncherOnHomepage: ['en-ca,', 'en-us', 'fr-ca']
    })
  }

  else {
    return enhancedLiveChat({
      cssPath: '/livechat/css/LiveChatCodeCanvasTNF.css',
      brand: 'TNF',
      languageConfig
    })
  }
})
